import React, { useMemo } from "react";
import Switch from "@mui/material/Switch";
import { Link } from "react-router-dom";
import DataTable from "../_Components/DataTable";
import ApiAmusementService from "../../../core/api/api.amusementService";
import Swal from "sweetalert2";
import SwalMessage from "../_Components/SwalMessage";

function DataGridAmusementServices({ data }) {
  async function deleteAmusementService(item) {
    Swal.fire({
      title: "عملیات حذف تفریح",
      text: "ایا قصد حذف این تفریح را دارید؟",
      icon: "question",
      showDenyButton: true,
      confirmButtonText: "بله",
      denyButtonText: "خیر",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap btn btn-secondary",
        confirmButton: "order-2 btn btn-success px-5",
        denyButton: "order-3 btn btn-danger px-5",
      },
      focusCancel: true
    }).then((result) => {
      if (result.isConfirmed) {
        deleteApi(item);
      } else if (result.isDenied) {
      }
    });
  }

  const deleteApi = async (id) => {
    const response = await ApiAmusementService.deleteAmusementService({ id: id });
    if (response.succeeded == true) document.getElementById("submitButton").click();
    SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  };

  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "شماره",
      minWidth: 50,
    },
    {
      accessor: "name",
      Header: "نام",
      minWidth: "100px",
    },
    {
      accessor: "urlName",
      Header: "urlName",
      minWidth: "100px",
    },
    {
      accessor: "amusementGroupTitle",
      Header: "نام گروه",
      minWidth: "100px",
      Cell: ({ row }) => {
        const groupTitles = row.original.amusementServiceAmusementGroups
          ?.map((grp) => grp.amusementGroup.title)
          .join("، ");
        return groupTitles;
      },
    },
    {
      accessor: "cityName",
      Header: "شهر",
      minWidth: "100px",
      Cell: ({ row }) => {
        const regionNames = row.original.amusementServiceRegions?.map((rgn) => rgn.region.name).join("، ");
        return regionNames;
      },
    },
    {
      Header: "وضعیت",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch
            checked={row.original.status ? true : false}
            //checked={state.checkedA}
            value="row.original.active"
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
          // onChange={handleChange(row.original)}
          />
        </div>
      ),
    },
    {
      accessor: "createdPersianTime",
      Header: "زمان ایجاد",
      minWidth: 90,
      maxWidth: 90,
    },

    {
      Header: "عملیات",
      accessor: "",
      minWidth: 150,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          {/* ویرایش */}
          <Link
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="ویرایش"
            to={`/createOrEditService/${row.original.id}`}
          >
            <i className="far fa-edit text-small"></i>
          </Link>
          <button
              onClick={(event) => deleteAmusementService(row.original.id)}
              className="btn btn-light-danger btn-sm btn-icon"
              type="button"
              title="حذف"
            >
              <i className="far fa-trash-alt text-small"></i>
            </button>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGridAmusementServices;
